import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { JobPublicationLabelComponent } from './job-publication-label.component';

@NgModule({
  declarations: [JobPublicationLabelComponent],
  exports: [JobPublicationLabelComponent],
  imports: [CommonModule],
})
export class JobPublicationLabelModule {}
